import { render } from "./pricingPage.vue?vue&type=template&id=c1d83d8e&scoped=true"
import script from "./pricingPage.vue?vue&type=script&lang=js"
export * from "./pricingPage.vue?vue&type=script&lang=js"

import "./pricingPage.vue?vue&type=style&index=0&id=c1d83d8e&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d83d8e"]])

export default __exports__